import { isNativeMobileApp } from "@/mobile/isOnIOS";
import { getPackagePrices } from "@/mobile/postMessage";
import { getBthPackages } from "@overlay/modules/apiAccess";
import { EPackageSize, TPackageItem } from "@overlay/types/enums";
import { computed, ref } from "vue";

// setting mobile prices as fallback. on recent version, they will be updated to the right region
export const packages = ref<{
  [key in EPackageSize]: TPackageItem;
}>({
  small: {
    mobileIdentifier: "small-sbth",
    mobilePrice: "$12.99",
    tokenAmount: -1,
    price: 9.99,
    bonus: 500,
    image: "chest_s",
    bonusImage: "5_bonus",
  },
  big: {
    mobileIdentifier: "large-sbth",
    mobilePrice: "$59.99",
    tokenAmount: -1,
    price: 49.99,
    bonus: 2000,
    image: "chest_l",
    bonusImage: "20_bonus",
  },
  medium: {
    mobileIdentifier: "medium-sbth",
    mobilePrice: "$24.99",
    tokenAmount: -1,
    price: 19.99,
    bonus: 1000,
    image: "chest_m",
    bonusImage: "10_bonus",
  },
  special: {
    mobileIdentifier: "special offer",
    mobilePrice: "$2.49",
    tokenAmount: -1,
    ticketsAmount: 13000,
    price: 1.99,
    bonus: 0,
  },
});

const mobileIdentifiers = computed(() =>
  Object.values(packages.value).map((el) => el.mobileIdentifier),
);

export async function getPackages(
  packagesRequested = [
    EPackageSize.SMALL,
    EPackageSize.BIG,
    EPackageSize.MEDIUM,
  ],
): Promise<{
  [key in EPackageSize]?: TPackageItem;
}> {
  const bthPackages = await getBthPackages();
  if (isNativeMobileApp()) {
    const offerings: Array<any> = (await getPackagePrices()).availablePackages;
    if (offerings) {
      offerings.forEach(
        (offering: {
          identifier: string;
          product: { priceString: string };
        }) => {
          if (mobileIdentifiers.value.includes(offering.identifier)) {
            for (const pkg in packages.value) {
              if (
                packages.value[pkg as EPackageSize].mobileIdentifier ==
                offering.identifier
              ) {
                packages.value[pkg as EPackageSize].mobilePrice =
                  offering.product.priceString;
              }
            }
          }
        },
      );
    }
  }
  bthPackages.forEach((bthPackage) => {
    if (packages.value[bthPackage.id] !== undefined) {
      packages.value[bthPackage.id]["tokenAmount"] = bthPackage.tokens;
    }
  });
  const returnObj: { [key in EPackageSize]?: TPackageItem } = {};
  for (const wantedPkg of packagesRequested) {
    Object.assign(returnObj, { [wantedPkg]: packages.value[wantedPkg] });
  }
  return returnObj;
}
